export function isHTML(str: string) {
  // Only treat as HTML if it contains HTML tags other than <br>
  return /<(?!br\s*\/?)[a-z][\s\S]*>/i.test(str);
}

export function removeOptionalBrTags(str: string) {
  return str.replace(/<br\s*\/?>/gi, "");
}

export function hasBrTags(str: string) {
  return /<br\s*\/?>/i.test(str);
}

export function decodeHtmlEntities(text: string): string {
  const txt = document.createElement("textarea");
  txt.innerHTML = text;
  return txt.value;
}